declare global {
  interface Window {
    connectionId?: string;
  }
}

export function getSignalRConnectionId(): string | undefined {
  return window.connectionId;
}
